import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Row,
  Col,
  Button,
  Input,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';
import Alert from 'react-s-alert';
import * as MyAPI from '../../utils/MyAPI'
import * as UserActions from '../../actions/UserActions'
import { LOCAL_STRAGE_KEY } from '../../utils/Settings'
import { useDispatch } from "react-redux";

// LoginForm
const LoginForm = (props) => {

  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  let dispatch = useDispatch();
  let navigate = useNavigate();

  let _handleEmailChange = (e) => {
    setEmail(e.target.value)
  }
  let _handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  let _onSubmit = async () => {


    props.setLoading(true)

    try {

      // check parameters
      if (!email) {
        throw Error("email is invalid")
      }
      if (!password) {
        throw Error("password is invalid")
      }

      // sign in with password
      let _results = await MyAPI.signinWithPassword({
        email: email,
        password: password,
      })

      if (!_results) {
        throw Error("something went wrong.")
      }

      if (_results.status !== 'success') {
        throw Error(_results.message)
      }

      let account_type = ""
      if (_results.user_info.profile && _results.user_info.profile.account_type) {
        account_type = _results.user_info.profile.account_type
      }

      if (account_type === "default" && _results.user_info.profile.email_verified !== true) {

        props.setLoading(false)

        navigate("/pre_registration")
        return;
      }

      // success
      let token_params = {
        user_info: _results.user_info,
        login_token: _results.login_token,
        createdAt: new Date(),
      }

      // save token
      localStorage.setItem(LOCAL_STRAGE_KEY, JSON.stringify(token_params.login_token))

      dispatch(UserActions.loginWithEmail(token_params))

      props.setLoading(false)

      // redirect
      if (account_type === "admin") {
        navigate("/dashboard")
      } else {
        navigate("/account")
      }

    } catch (err) {
      console.log("err:", err)

      props.setLoading(false)

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
  }

  return(

    <div>

      {/* email */}
      <Row style={{
        marginTop: 10,
        marginBottom: 10,
      }}>
        <Col md="3" xs="12" />
        <Col md="6" xs="12" style={{ textAlign: 'left' }}>

          <div className="shadow2dp" style={{
            backgroundColor: '#ffffff',
            padding: 20,
          }}>

          <Row style={{
            marginTop: 10,
            marginBottom: 10,
          }}>
            <Col md="12" xs="12">

              <span>email</span><br/>
              <Input
                type="email"
                style={{width: '100%'}}
                name='email'
                onChange={_handleEmailChange}
                value={email}
                placeholder='steeve@example.com' />

            </Col>
          </Row>


          <Row style={{
            marginTop: 10,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12">

              <span>password</span><br/>
              <Input
                type="password"
                style={{width: '100%'}}
                name='password'
                onChange={_handlePasswordChange}
                value={password}
                placeholder='********' />

            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 10,
          }}>
            <Col md="12" xs="12">

              <Button
                onClick={_onSubmit}
                color="primary"
                style={{
                  cursor: 'pointer',
                  width: '100%',
                }}>
                ログイン
              </Button>

            </Col>
          </Row>

        </div>

        </Col>
        <Col md="3" xs="12" />
      </Row>
    </div>
  )
}

export default LoginForm
